import { useEffect } from 'react';

const updateLaunchDarklyData = ({
  spaceId,
  currentUserId,
  institutionName,
  launchDarklyClient,
}) => {
  launchDarklyClient.identify({
    key: currentUserId,
    custom: {
      spaceId,
      institution: institutionName,
    },
  });
};

export default ({
  spaceId,
  currentUserId,
  institutionName,
  launchDarklyClient,
}) => {
  useEffect(
    () =>
      updateLaunchDarklyData({
        launchDarklyClient,
        currentUserId,
        institutionName,
        spaceId,
      }),
    [spaceId]
  );
};
